module.exports = __webpack_public_path__ + "img/cambodia.51bd6c70.svg";